<div class="common-table-style">
  <div class="header-box">
    <div class="d-flex align-items-center heading-box">
      <ng-icon name="heroGlobeAsiaAustralia"></ng-icon>
      <h2>Role</h2>
    </div>
    <div class="d-flex justify-content-between align-items-center col-md-6 p-0">
      <div class="dense-4 search-and-filter">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Search Role</mat-label>
          <input matInput (keyup)="applyFilter($event.target.value)" autocomplete="off">
          <mat-icon matSuffix><ng-icon name="heroMagnifyingGlass"></ng-icon></mat-icon>
        </mat-form-field>
      </div>
      <button color="accent" mat-raised-button
      *ngIf="userService.permissionsValue['_USER_MANAGEMENT_ADD_']" [routerLink]="['/app/role','new','0']">
      Add Role </button>
    </div>
  </div>
  <div class="inner-box">
    <mat-table class="user-table" [dataSource]="dataSource" matSort (matSortChange)="customSortData($event)">
      <ng-container matColumnDef="Role Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Role Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button color="accent" disableRipple 
            [routerLink]="['/app/role', 'view', element.id]" matTooltip="View User {{ element.name | titlecase}}" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">{{ element.name  | titlecase
            }}</a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="User Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Role Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.name | titlecase }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Created By">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Created By</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{element.createdBy | titlecase }}
        </mat-cell>
      </ng-container>

      <!-- <ng-container matColumnDef="Email Address">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Email Address</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.officialEMail }}</mat-cell>
      </ng-container> -->

      <ng-container matColumnDef="Last Updated">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-progress-spinner mode="indeterminate" color="accent" diameter="30"
            *ngIf="isLoading[element.id]; else loaded"></mat-progress-spinner>
          <ng-template #loaded>
            {{ element.updateDate  }}
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
        <mat-cell *matCellDef="let element">

          <mat-progress-spinner mode="indeterminate" color="accent" diameter="30"
            *ngIf="isLoading[element.id]; else loaded"></mat-progress-spinner>
          <ng-template #loaded>
            <label class="switch">
              <input class="switch-input" type="checkbox" [checked]="element.status === 1"
                (change)="toggleOrgStatus(element)">
              <div class="switch-button">
                <span class="switch-button-left">Inactive</span>
                <span class="switch-button-right">Active</span>
              </div>
            </label>
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Action">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>
        <mat-cell *matCellDef="let element" class="action">
          <a mat-button color="accent" disableRipple 
          *ngIf="userService.permissionsValue['_USER_MANAGEMENT_EDIT_']" [routerLink]="['/app/role','edit',element.id]" matTooltip="Edit User {{ element.name | titlecase}}"[matTooltipShowDelay]="300" [matTooltipHideDelay]="100"><ng-icon name="heroPencil"></ng-icon></a>

          <!-- <a mat-button color="accent" disableRipple 
          (click)="openDeleteConfirmation(element.id)" matTooltip="Delete User {{ element.organizationName | titlecase}}"[matTooltipShowDelay]="300" [matTooltipHideDelay]="100"><ng-icon name="heroTrash"></ng-icon></a> -->
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

    </mat-table>

    <ng-container *ngIf="dataSource.filter &&  dataSource.filteredData.length === 0">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p>There are no users found with <strong>'{{dataSource.filter}}'</strong></p>
      </div>
    </ng-container>

    <ng-container *ngIf="dataSource.data.length === 0">
      <div class="skeleton-box">
        <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
      </div>
    </ng-container>

    <mat-paginator [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>

<!-- <div class="content-wrapper">
  <div class="top-heading py-4 pl-3">

    <span  id="roleCreated">{{usermanagementService.alertMessage}}</span>
    <button type="button" class="btn btn-secondary mx-4" *ngIf="userService.permissionsValue['_USER_MANAGEMENT_ADD_']" [routerLink]="['/app/role','new','0']">Add</button>

    </div>
    <div class="whitebackground mx-3 bg-white py-3">
    <div class="container-fluid">
      <div class="table-responsive-lg">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">Role Name<i class="fa fa-sort pl-2" aria-hidden="true"></i>
            </th>
            <th scope="col">Created By<i class="fa fa-sort pl-2" aria-hidden="true"></i>
            </th>
           
            <th scope="col">Status</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let role of usermanagementService.allroles;let i = index">
            <td>{{role.name}}</td>
            <td>{{role.createdBy}}</td>
            <td>
              
              <ui-switch [checked]="role.status == 1" (valueChange)="onValueChange(role,$event)" checkedLabel="Active" uncheckedLabel="Inactive" size="small"></ui-switch>
              <label class="switch">
              <input type="checkbox" [checked]="role.status">
              <span class="slider round"></span>
            </label>

          </td>
            <td><i class="fa fa-pencil pr-2" aria-hidden="true" *ngIf="userService.permissionsValue['_USER_MANAGEMENT_EDIT_']" [routerLink]="['/app/role','edit',role.id]"></i>
              <i class="fa fa-eye" aria-hidden="true" *ngIf="userService.permissionsValue['_USER_MANAGEMENT_VIEW_']" [routerLink]="['/app/role','view',role.id]"></i>

            </td>
          </tr>
          
        </tbody>
      </table>
      </div>
        <div class="row justify-content-end pr-4 pt-3">

    </div>
      </div>
      </div>
 </div> -->
